import {
    Component,
    computed,
    DestroyRef,
    effect,
    ElementRef,
    HostListener,
    inject,
    input,
    OnDestroy,
    output,
    signal,
} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CROService} from '../../../services/cro.service';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-search-cro',
    imports: [FormsModule],
    templateUrl: './search-cro.component.html',
    standalone: true,
    styleUrl: './search-cro.component.scss',
})
export class SearchCroComponent implements OnDestroy {
    croService = inject(CROService);
    private elementRef = inject(ElementRef);
    private destroyRef = inject(DestroyRef);
    

    croName = input<string | undefined>(undefined);
    croId = input<number | undefined>(undefined);
    deliveredQty = input<number>(-1);
    croStatus = input<number>(1);
    selectedCRO = output<any>();

    searchTerms = signal({
        emp_id: -1,
        employee_name: '',
        status: this.croStatus(),
        items_per_page: -1,
        page_number: 1,
        work_title: 4,
    });

    filterValue = signal<string>('');
    isListVisible = signal<boolean>(false);
    disabled = input<boolean>(false);

    cro = computed(() => this.croService.all());
    selectedCustomer = computed(() => this.croService.active());

    constructor() {
        effect(() => {
            this.croService
                .find(this.searchTerms(), true)
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe({
                    next: () => {},
                    error: (error) => console.error(error),
                });
        });

        effect(() => {
            const activeCRO = this.selectedCustomer();
            if (activeCRO) {
                this.filterValue.set(activeCRO.fullName || '');
                this.selectedCRO.emit(activeCRO);
            } else {
                this.filterValue.set('');
                this.selectedCRO.emit(null);
            }
        });

        effect(() => {
            const newCroId = this.croId();
            if (newCroId === null || newCroId === -1) {
                this.clearSelection();
            } else if (typeof newCroId !== 'undefined' && newCroId !== 0) {
                this.onOptionSelected(newCroId);
            }
        });

    }

    ngOnDestroy(): void {
        this.clearSelection()
    }
    
    selectAll(event: MouseEvent): void {
        (event.target as HTMLInputElement).select();
    }

    onInputChange(value: string): void {
        this.filterValue.set(value);
        this.searchTerms.set({
            ...this.searchTerms(),
            employee_name: value,
            page_number: 1,
        });
        if (value.trim() === '') {
            this.selectedCRO.emit(-1);
            this.clearSelection();
        }
    }

    onOptionSelected(id: number) {
        this.isListVisible.set(false);
        this.croService.getById(String(id), true)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: () => {
                    this.selectedCRO.emit(id);
                },
                error: (error) => console.error(error),
            });
    }

    clearSelection(): void {
        this.filterValue.set('');
        this.croService.initial();
        this.searchTerms.set({
            emp_id: -1,
            employee_name: '',
            status: this.croStatus(),
            items_per_page: -1,
            page_number: 1,
            work_title: 4,
        });
    }

    @HostListener('document:click', ['$event'])
    clickOutsideDropdown(event: any): void {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.isListVisible.set(false);
        }
    }
}